import React from "react";
import NavbarComponent from "../component/NavbarComponent";
import { motion } from "framer-motion";

const AboutUs = () => {
  return (
    <React.Fragment>
      <NavbarComponent />

      {/* Academics Section start */}
      <div className="min-h-screen">
        <div className="lg:pl-20 md:pl-20">
          <div className="p-1 lg:grid lg:grid-cols-2 lg:gap-x-4 sm:grid-row-2 md:grid md:grid-cols-2 gap-4">
            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: -100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className=" text-lg  text-left p-5 lg:p-10 my-2 rounded-lg  row-span-2 "
            >
              <h2 className="text-2xl  text-indigo-600 font-bold">About Us</h2>
              <p className="text-sm mt-2">
                Bokaro Ispat Senior Secondary School, 8B, is an English medium
                co-educational CBSE school. It was established in the year
                1991.This school is directly managed by SAIL, Bokaro Steel Plant
                under its welfare scheme. Besides the wards of steel plant
                employees, children from under-privileged families of the local
                populace form a large part of its student population. Some
                students from far-off places also prefer to read in this school
                staying in hostels or with relatives.
              </p>
              <p className="text-sm mt-2">
                The school facilitates science, commerce and arts streams in
                classes XI and XII. Affiliated to CBSE it has set its mission on
                'all round development' of students by creating an affable
                learning environment in the campus. Apart from academics, the
                school emphasizes on personality development too. It is a matter
                of great pleasure that now-a-days CBSE has also included value
                based education in its curriculum.
              </p>
              <p className="text-sm mt-2">
                Games and sports, music, fine arts, yoga etc. are some of the
                means by which our students relax themselves to take away the
                monotony of class room teaching. Self discipline on the part of
                students is an excellent asset for the school. We are proud to
                announce that our students traditionally imbibe it from their
                seniors. All these could not have been possible but for a team
                of dedicated and well qualified teachers.
              </p>
              <div className="text-black-500  mt-2">
                <div className="grid grid-row-2">
                  <div className="mb-2">
                    <h4 className="ml-2 font-bold">Vision:</h4>
                    <p className="text-sm ml-2">
                      To be a respected institution and the leader in imparting
                      of learning skills in terms of quality, value based
                      education, nation building and stake holders'
                      satisfaction.
                    </p>
                  </div>
                  <div></div>
                </div>
              </div>
            </motion.div>

            <motion.div
              whileInView={{ opacity: 1, x: 0 }}
              initial={{ opacity: 0, x: 100 }}
              transition={{ duration: 0.5, delay: 0.5 }}
              viewport={{ once: true }}
              className="text-lg  text-center lg:p-10 mt-5 pl-5 pr-5 rounded-lg  row-span-2"
            >
              <div className="lg:mb-8 text-left">
                <h2 className="text-2xl  text-indigo-600 font-bold">
                  Admission & Fee
                </h2>
                <span className="text-sm">Admission Process:</span>
                <p className="text-sm">
                  Students are enrolled in class I & Class XI. Class I admission
                  is purly on lottery basis in frot of availabe parents as per
                  BSL Norms of social reservation category. In Class XI purly on
                  merit basis but social reservation norms are also adhered to.
                  Direct Admission to 95% and above cadndidates whose tution
                  fees are exempted. Any applicant of SAIL, BSL Emplyee category
                  is admitted to any class as per CBSE norms in beginning of
                  session i.e. in April every year
                </p>
                <span className="text-sm">
                  Fee Payment procedure throuth SBI i-collect:
                </span>
                <ol className="text-sm list-decimal px-5 lg:mt-8 ">
                  <li>Go to www.onlinesbi.com</li>
                  <li>
                    Select "Stat Bank collect I Collect” link on the home page
                  </li>
                  <li>
                    Click Check box to accept terms and conditions and press
                    proceed button.
                  </li>
                  <li>
                    Select State of Corporate/Institution & Type of
                    Corporate/Institution from the drop down menu-Jharkhand &
                    Industry Click 'Go' button.
                  </li>
                  <li>
                    Select the name of the Coroporate/institution from the drop
                    down menu -STEEL AUTHORITY OF INDIA LIMITED. Click 'Submit'
                    button
                  </li>
                  <li>
                    Enter Name, DOB, Mobile No. & captcha. Click 'Submit' button
                  </li>
                  <li>
                    Now the State Bank Collect payment verification page will
                    appear where the payer has to click on the 'Confirm' button
                    after verifying the payment details to proceed further.
                  </li>
                  <li>
                    Select options of payment i.e. credit card, ATM or net
                    banking of different listed banks & pay.
                  </li>
                  <li>Take print out of fee payment and submit in school.</li>
                </ol>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
      {/* Academics Section end */}

      <footer className="border-t-2">
        <div className="text-center font-bold p-6 bg-white">
          <span className="text-black">© 2022 - </span>
          <span className="text-black text-lg font-bold hover:text-blue-300 ">
            BISSS-8B
          </span>
          <span className="text-black">
            , Education Department, Bokaro Steel Plant
          </span>
        </div>
      </footer>
    </React.Fragment>
  );
};

export default AboutUs;
